<template>
  <BaseModal :closable="false">
    <template #header>
      <BaseModalHeader :header="t('module_access_changed_title')" />
    </template>
    {{ t('module_access_changed_description') }}
    <template #footer>
      <BaseModalButtonsFooter>
        <BaseButton data-external="module-access-changed-modal-button" @click="$emit('close')"
          >{{ t('qes_information_modal_button_text') }}
        </BaseButton>
      </BaseModalButtonsFooter>
    </template>
  </BaseModal>
</template>
<script>
import { defineComponent } from '@vue/composition-api';
import { ButtonType, ModalSize } from '@getaccept/lib-ui';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';

export default defineComponent({
  setup() {
    return { ButtonType, ModalSize, t };
  },
});
</script>
